<template>
  <div class="home container">
    <div class="content-search">
      <div class="content-input">
        <img class="icon" src="@/assets/images/home/icon_search.png" alt="">
        <input class="input-search" placeholder="感谢您来这里寻找创意" type="text" v-model="keywords" @keyup.enter="searchHandler()">
      </div>
      <span class="search" @click.stop="searchHandler()">搜索</span>
    </div>
    <div class="content-tab">
      <div class="item-tab" @click.stop="switchTabHandler(0)">
        <span class="name" :class="{'name-select':selectTabIndex === 0}">H5</span>
        <div class="line" :class="{'line-select':selectTabIndex === 0}"></div>
      </div>
      <div class="item-tab" @click.stop="switchTabHandler(1)">
        <span class="name" :class="{'name-select':selectTabIndex === 1}">小程序</span>
        <div class="line" :class="{'line-select':selectTabIndex === 1}"></div>
      </div>
      <div class="item-tab" @click.stop="switchTabHandler(2)">
        <span class="name" :class="{'name-select':selectTabIndex === 2}">朋友圈广告</span>
        <div class="line" :class="{'line-select':selectTabIndex === 2}"></div>
      </div>
      <div class="item-tab" @click.stop="switchTabHandler(3)">
        <span class="name" :class="{'name-select':selectTabIndex === 3}">短视频</span>
        <div class="line" :class="{'line-select':selectTabIndex === 3}"></div>
      </div>
    </div>
    <div class="list-case">
      <div class="item-case" v-for="(item, index) in caseList" :key="index" @click.stop="showNoticeDialogHandler(item.caseUrl)">
        <img class="bg" :src="item.thumbnailUrl" alt="">
        <span class="title" v-text="item.title"></span>
      </div>
    </div>
    <div class="bg-dialog" v-if="showDialog" @click.stop="closeDialogHandler()">
      <div class="content-dialog" @click.stop="notDo()">
        <div class="dialog-notice">
          <span class="notice">本页面还没有做移动端适配建议到PC上访问本页面</span>
          <span class="link">www.h6app.com</span>
          <div class="content-btn">
            <span class="open" @click.stop="openLinkHandler()">直接打开</span>
            <div class="line"></div>
            <span class="copy" @click.stop="copyLinkHandler()">复制链接</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSearch } from '@/api/common'
// import { SEARCHARGS } from '@/utils/constants'
export default {
  name: 'home',
  components: {
  },
  data () {
    return {
      caseUrl:'',
      showDialog: false,
      dialogInfo: {
        title: '私域流量解决方案',
        desc: '体验私域流量的价值',
        peopleName: '子萱',
        peopleAvatar: require('../assets/images/growth/avatar1.png'),
        peoplePosition: '未来应用 私域流量专家',
        peoplePhone: '电话：185 1813 3416',
        qr: require('../assets/images/growth/qr_xiaoshimei.jpeg')
      },
      selectTabIndex: 0,
      caseList: [],
      pageSize: 10,
      pageNum: 1,
      caseTypeId: 1,
      keywords: '',
      REQUIRE: true
    }
  },
  methods: {
    getScroll () {
      return {
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
        height: window.scrollHeight || document.documentElement.scrollHeight || document.body.scrollHeight || 0
      }
    },
    scrollBottom () {
      if (((window.screen.height + this.getScroll().top) + 10 > (this.getScroll().height)) && this.REQUIRE) {
        this.REQUIRE = false
        this.loading = true
        this.pageNum = this.pageNum + 1
        this.loadCase()
      }
    },
    showNoticeDialogHandler (caseUrl) {
      this.showDialog = true
      this.caseUrl = caseUrl
    },
    openLinkHandler () {
      window.location.href = this.caseUrl
    },
    copyLinkHandler () {
      const that = this
      this.$copyText(this.caseUrl).then(function (e) {
        that.$toast('成功复制到剪切板')
      }, function (e) {
        that.$toast('复制失败')
        console.log(e)
      })
    },
    switchTabHandler (index) {
      this.selectTabIndex = index
      this.caseTypeId = index + 1
      this.searchCase()
    },
    searchHandler () {
      this.pageNum = 1
      this.searchCase()
    },
    // 获取 搜索案例
    async searchCase () {
      const res = await getSearch({
        pageSize: 10,
        pageNum: this.pageNum,
        caseTypeId: this.caseTypeId,
        keywords: this.keywords
      })
      this.REQUIRE = true
      this.loading = false
      if (res.ok) {
        this.caseList = res.list || []
      }
    },
    async loadCase () {
      const res = await getSearch({
        pageSize: 10,
        pageNum: this.pageNum,
        caseTypeId: this.caseTypeId,
        keywords: this.keywords
      })
      this.REQUIRE = true
      this.loading = false
      if (res.ok) {
        this.caseList = this.caseList.concat(res.list || [])
        console.log(res)
      }
    },
    showDialogHandler (index) {
      this.dialogInfo = this.contentDialogList[index]
      this.showDialog = true
    },
    closeDialogHandler () {
      this.showDialog = false
    },
    callPhoneHandler (phoneNum) {
      window.location.href = 'tel:' + phoneNum
    },
    notDo () {

    },
    // 滚动到指定元素
    scrollToDom () {
      document.getElementById('contact').scrollIntoView()
    }
  },
  mounted () {
    this.searchCase()
    window.addEventListener('scroll', this.scrollBottom)
  }
}
</script>

<style lang="less" scoped>
.home {
  background-color: #ffffff;
  margin-bottom: 98px;
  .content-search {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    margin-top: 40px;
    .content-input {
      display: flex;
      height: 100%;
      flex: 1;
      align-items: center;
      border-radius: 8px;
      background-color: #F4F4F4;
      margin-left: 40px;
      .icon {
        width: 28px;
        height: 28px;
        margin-left: 16px;
      }
      .input-search {
        flex: 1;
        line-height: 36px;
        color: #333333;
        font-size: 24px;
        border: 0;
        outline: none;
        padding: 0 16px;
        background-color: #F4F4F4;
      }
    }
    .search {
      font-size: 28px;
      color: #333333;
      line-height: 44px;
      font-weight: 400;
      margin-left: 18px;
      margin-right: 56px;
    }
  }
  .content-tab {
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-top: 32px;
    .item-tab {
      flex: 1;
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .name {
        font-size: 28px;
        color: #333333;
        font-weight: 400;
        line-height: 40px;
        margin-top: 12px;
      }
      .name-select {
        color: #FF6845;
      }
      .line {
        margin-top: auto;
        width: 40px;
        height: 4px;
        border-radius: 4px;
      }
      .line-select {
        background-color: #FF6845;
      }
    }
  }
  .list-case {
    width: 100%;
    margin-top: 40px;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    .item-case {
      width: 294px;
      display: flex;
      flex-direction: column;
      margin: 0 20px 46px;
      .bg {
        width: 100%;
        height: 480px;
        border-radius: 8px;
      }
      .title {
        font-size: 24px;
        color: #333333;
        font-weight: 400;
        line-height: 34px;
        margin-top: 16px;
        display: -webkit-box;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow:ellipsis;
      }
    }
  }
  .bg-dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.4);
    .content-dialog {
      width: 490px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .dialog-notice {
        width: 100%;
        height: 346px;
        border-radius: 12px;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        .notice {
          width: 344px;
          margin-top: 60px;
          font-size: 28px;
          color: #333333;
          line-height: 40px;
          font-weight: 400;
          text-align: center;
        }
        .link {
          font-size: 28px;
          color: #2A87FF;
          font-weight: 400;
          line-height: 44px;
          margin-top: 20px;
          text-align: center;
          text-decoration: underline;
        }
        .content-btn {
          width: 100%;
          height: 92px;
          display: flex;
          align-items: center;
          border-top: 1px solid #F4F4F4;
          margin-top: auto;
          .open {
            flex: 1;
            height: 100%;
            font-size: 32px;
            font-weight: 400;
            line-height: 92px;
            color: #333333;
            text-align: center;
          }
          .line {
            width: 1px;
            height: 100%;
            background-color: #F4F4F4;
          }
          .copy {
            flex: 1;
            height: 100%;
            font-size: 32px;
            font-weight: 400;
            line-height: 92px;
            color: #333333;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
